document.querySelectorAll( '.wp-block-wdg-language-switcher' ).forEach( ( block ) => {
	const button = block.querySelector( '.wp-block-wdg-language-switcher__button' );
	const list = block.querySelector( '.wp-block-wdg-language-switcher__list' );

	if ( ! button || ! list ) {
		return;
	}

	const links = list.querySelectorAll( '.wp-block-wdg-language-switcher__link' );

	let currentIndex = -1;
	let isOpen = false;

	const toggleDropdown = ( open ) => {
		const shouldOpen = open !== undefined ? open : ! isOpen;

		if ( shouldOpen ) {
			button.classList.add( 'is-active' );
			list.classList.add( 'is-active' );
			button.setAttribute( 'aria-expanded', 'true' );
			isOpen = true;
		} else {
			button.classList.remove( 'is-active' );
			list.classList.remove( 'is-active' );
			button.setAttribute( 'aria-expanded', 'false' );
			currentIndex = -1;
			isOpen = false;
		}
	};

	const focusLink = ( index ) => {
		if ( index >= 0 && index < links.length ) {
			links[ index ].focus();
			currentIndex = index;
		}
	};

	button.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		toggleDropdown();
	} );

	button.addEventListener( 'keydown', ( e ) => {
		switch ( e.key ) {
			case 'Enter':
			case ' ':
				e.preventDefault();
				toggleDropdown( true );
				focusLink( 0 );
				break;
			case 'ArrowDown':
				e.preventDefault();
				if ( ! isOpen ) toggleDropdown( true );
				focusLink( 0 );
				break;
			case 'ArrowUp':
				e.preventDefault();
				if ( ! isOpen ) toggleDropdown( true );
				focusLink( links.length - 1 );
				break;
			case 'Escape':
				if ( isOpen ) {
					toggleDropdown( false );
					button.focus();
				}
				break;
		}
	} );

	list.addEventListener( 'keydown', ( e ) => {
		if ( ! isOpen ) return;

		switch ( e.key ) {
			case 'ArrowDown':
				e.preventDefault();
				focusLink( ( currentIndex + 1 ) % links.length );
				break;
			case 'ArrowUp':
				e.preventDefault();
				focusLink( ( currentIndex - 1 + links.length ) % links.length );
				break;
			case 'Escape':
				e.preventDefault();
				toggleDropdown( false );
				button.focus();
				break;
			case 'Tab':
				toggleDropdown( false );
				break;
		}
	} );

	list.addEventListener( 'click', ( e ) => {
		e.stopPropagation();
	} );

	document.addEventListener(
		'click',
		( e ) => {
			if ( isOpen && ! block.contains( e.target ) ) {
				toggleDropdown( false );
			}
		},
		true
	);
} );
